module.exports = __webpack_public_path__ + "ab534dd3fc6ee11e5c410d63a5401030.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-8.png
// module id = 3143
// module chunks = 0